<template>
  <card-canvas unstick-header size="medium">
    <template #header>
      <item-create-topbar
        :entity-id="projectID"
        :entity-name="projectName"
        :entity-type="EEntities.PROJECTS"
      />
    </template>
    <!-- CREATE TASK -->
    <add-task-form
      :selected-project-id="projectID"
      @task-created="(taskID, createAnother) => handleTaskCreated(taskID, createAnother)"
      @project-name-updated="(val) => projectName = val"
      @canceled="$router.go(-1)"
    />
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'TaskCreate',

  components: {
    CardCanvas,
  },

  data() {
    return {
      EEntities,
      projectName: '',
      RouteAssistant,
    }
  },

  head: {
    title: 'New Task',
  },

  computed: {
    projectID(): number {
      return Number(this.$route.params.id)
    },
  },

  mounted() {
    // Pre-seed data from the route.params to seed the breadcrumb listing picker title before the API call...
    if (RouteAssistant.routeState(this.$route, 'projectName')) {
      this.projectName = RouteAssistant.routeState(this.$route, 'projectName')
    }
  },

  methods: {
    handleTaskCreated(taskID: number, createAnother: boolean) {
      if (createAnother) {
        this.scrollToTop()
      } else {
        RouteAssistant.goToTask(
          this.$router,
          this.$route.params.accountId,
          this.projectID,
          taskID,
          this.$permissions,
        )
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
})
</script>

<style lang="scss">
</style>
